import React from 'react'
import { useEffect, useState } from "react";
import '../assets/css/header.css'
import { IoCall } from 'react-icons/io5';
import { IoIosMenu } from 'react-icons/io';
import { RxCross2 } from 'react-icons/rx';
import QuoteModal from './QuoteModal';
import { useNavigate } from 'react-router-dom';

function Header({ onProductClick, onIndustryClick }) {

    const [show, setShow] = useState(true);
    const [menuOpen, setMenuOpen] = useState(false);
    const [lastScrollY, setLastScrollY] = useState(0);
    const [open, setOpen] = useState(false)
    const navigate = useNavigate()

    useEffect(() => {
        const onScroll = () => {
            const currentScrollY = window.scrollY;

            if (currentScrollY < lastScrollY) {
                setShow(true);
            } else if (currentScrollY > lastScrollY && currentScrollY > 80) {
                setShow(false);
            }
            setLastScrollY(currentScrollY);
        };

        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, [lastScrollY]);

    useEffect(() => {
        document.body.style.overflow = menuOpen ? "hidden" : "auto";
    }, [menuOpen]);

    const handleProductsClick = () => {
        setMenuOpen(false)
        navigate("/", { state: { scrollTo: "products" } });
    };

    const handleIndustriesClick = () => {
        setMenuOpen(false)
        navigate("/", { state: { scrollTo: "industries" } });
    };

    return (
        <>
            <header className={`header ${show ? "header--visible" : "header--hidden"}`}>
                <div className="header__container header--animate">
                    <div className="header__logo" onClick={() => navigate('/')}>
                        <img src={require('../assets/images/logo.png')} alt="" />
                    </div>

                    <nav className="header__nav">
                        <a href="/about-us">Company</a>
                        <a href="/#products" onClick={handleProductsClick} style={{ cursor: 'pointer' }}>Products</a>
                        <a href="/latest-products">Latest Products</a>
                        <a href="/#industries" onClick={handleIndustriesClick} style={{ cursor: 'pointer' }}>Industries We Serve</a>
                        <a href="/contact-us">Contact</a>
                    </nav>

                    <div className="header__actions">
                        <a className="call-btn call-btn-multi" href="tel:+918160995833">
                            <div className="call-line">
                                <IoCall />
                                <span>+91 9586127173</span>
                            </div>
                            <div className="call-line">
                                <IoCall />
                                <span>+91 9979619001</span>
                            </div>
                        </a>
                        <button className="animated-btn" onClick={() => setOpen(true)}>
                            <span className="btn-text-wrap">
                                <span className="btn-text">Free Quote</span>
                                <span className="btn-text btn-text-abs">Free Quote</span>
                            </span>
                        </button>
                        {
                            menuOpen === true ? (
                                <button className="header__menu" onClick={() => setMenuOpen(false)}><RxCross2 /></button>
                            ) : (
                                <button className="header__menu" onClick={() => setMenuOpen(true)}><IoIosMenu /></button>
                            )
                        }
                    </div>
                </div>
            </header>

            <QuoteModal isOpen={open} onClose={() => setOpen(false)} />

            {/* Mobile Menu Overlay */}
            <div className={`mobile-overlay ${menuOpen ? "open" : ""}`} onClick={() => setMenuOpen(false)} />

            {/* Mobile Slide Menu */}
            <div className={`mobile-menu ${menuOpen ? "open" : ""}`} style={{margin:'20px 0 0'}}>
                <button className="mobile-menu__close" onClick={() => setMenuOpen(false)}>×</button>
                <a href="/about-us" onClick={() => setMenuOpen(false)}>Company</a>
                <a href="/#products" onClick={handleProductsClick}>Products</a>
                <a href="/latest-products" onClick={() => setMenuOpen(false)}>Latest Products</a>
                <a href="/#industries" onClick={handleIndustriesClick}>Industries We Serve</a>
                <a href="/contact-us" onClick={() => setMenuOpen(false)}>Contact</a>
                <button className="mobile-menu__cta">Free Quote</button>
                <div className="mobile-menu__cta mobile-call-multi">
                    <a href="tel:+918160995833" className="mobile-call-line">
                        <IoCall />
                        <span>+91 8160995833</span>
                    </a>

                    <a href="tel:+919979619001" className="mobile-call-line">
                        <IoCall />
                        <span>+91 9979619001</span>
                    </a>

                    <a href="tel:+919586127173" className="mobile-call-line">
                        <IoCall />
                        <span>+91 9586127173</span>
                    </a>
                </div>
            </div>
        </>
    )
}

export default Header